import { getApi, postApi } from 'util/api';
import { FSPS } from 'consts';

const baseURL = (fspId) => `/auth/${FSPS}/${fspId}/pal-ifp/enrollments`;

export const createEnrollment = (fspId) => postApi(baseURL(fspId));

export const getEnrollmentState = (fspId) => getApi(`${baseURL(fspId)}/state`);

export const updateDesiredState = ({ fspId, onApiErrors, ...params }) =>
  postApi(`${baseURL(fspId)}/desired-state`, { ...params });

export const reconcileEnrollment = (fspId) =>
  postApi(`${baseURL(fspId)}/reconciliations`);

// Regenerates Cognito managed-login branding.settings from the FSP SSO overwrite
// theme (server-side) and queues the resulting UPDATE.
export const styleSyncEnrollment = ({ fspId, reason }) =>
  postApi(`${baseURL(fspId)}/style-sync`, { reason });

export const getOperations = ({ fspId, limit, nextToken }) => {
  const queryParams = new URLSearchParams();
  if (limit) queryParams.append('limit', limit);
  if (nextToken) queryParams.append('nextToken', nextToken);
  const qs = queryParams.toString();
  const url = qs
    ? `${baseURL(fspId)}/operations?${qs}`
    : `${baseURL(fspId)}/operations`;
  return getApi(url);
};

export const getOperation = ({ fspId, operationId }) =>
  getApi(`${baseURL(fspId)}/operations/${operationId}`);

export const resetEnrollment = () => Promise.resolve({});

export const getBrandingPresignedUrl = ({ fspId, slotName, extension }) =>
  postApi(`${baseURL(fspId)}/branding/assets/${slotName}/presigned-urls`, {
    extension,
  });
